import React from 'react';
import { Box, Typography } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import Barcode from 'react-barcode';

const OrderCodes = ({ order }) => {
  if (!order) return null;

  const qrData = JSON.stringify({
    id: order._id,
    orderNumber: order.orderNumber,
    customer: order.userId?.name || order.shippingAddress?.name || '',
    email: order.userId?.email || '',
    phone: order.shippingAddress?.phone || order.userId?.phone || '',
    items: order.items?.map(i => ({
      name: i.productName || i.productId?.name,
      qty: i.quantity,
      price: i.price,
    })) || [],
    subtotal: order.subtotal,
    shipping: order.shippingCharge,
    tax: order.tax,
    total: order.total,
    status: order.orderStatus,
    paymentStatus: order.paymentStatus,
    tracking: order.trackingNumber || '',
    address: order.shippingAddress ? {
      name: order.shippingAddress.name,
      phone: order.shippingAddress.phone,
      city: order.shippingAddress.city,
      state: order.shippingAddress.state,
    } : null,
    date: order.createdAt,
  });

  return (
    <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', flexWrap: 'wrap' }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>QR Code</Typography>
        <Box sx={{ bgcolor: '#fff', p: 1, borderRadius: 1, border: '1px solid #e0e0e0', display: 'inline-block' }}>
          <QRCodeSVG value={qrData} size={100} />
        </Box>
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>Barcode</Typography>
        <Box sx={{ bgcolor: '#fff', p: 1, borderRadius: 1, border: '1px solid #e0e0e0', display: 'inline-block' }}>
          <Barcode value={order.orderNumber || order._id} height={40} width={1.5} fontSize={11} margin={0} />
        </Box>
      </Box>
    </Box>
  );
};

export default OrderCodes;
